import { render, staticRenderFns } from "./Category02.vue?vue&type=template&id=5c19dc18&scoped=true"
import script from "./Category02.vue?vue&type=script&lang=js"
export * from "./Category02.vue?vue&type=script&lang=js"
import style0 from "./Category02.vue?vue&type=style&index=0&id=5c19dc18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c19dc18",
  null
  
)

export default component.exports